import React, {ReactNode, useState, useRef} from 'react'
import {createPortal} from 'react-dom'
import {useFloating, FloatingArrow, arrow, useInteractions, useHover, offset, UseFloatingOptions, Placement, flip} from '@floating-ui/react'
import styles from './Tooltip.module.scss'
import clsx from 'clsx'

export interface TooltipProps {
    children: ReactNode
    content?: ReactNode | string
    title?: ReactNode | string
    position?: Placement | undefined
    className?: string
    menuClassName?: string
    centerText?: boolean | undefined
    delay?: number | undefined
}

export const Tooltip = ({children, content, position, className, menuClassName, title, centerText, delay = 200}: TooltipProps) => {
    const [isOpen, setIsOpen] = useState(false)
    const arrowRef = useRef(null)

    const option: UseFloatingOptions = {
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [
            arrow({element: arrowRef}),
            offset(10),
            flip(),
        ],
    }

    if(position) option.placement = position

    const {refs, floatingStyles, context} = useFloating(option)
    const hover = useHover(context, {delay: delay})
    const {getReferenceProps, getFloatingProps} = useInteractions([hover])

    return (
        <>
            <div className={clsx(styles.tooltipTrigger, className)} ref={refs.setReference} {...getReferenceProps()}>
                {children}
            </div>
            {isOpen && createPortal(<div
                className={clsx(styles.tooltipMenu, menuClassName)}
                ref={refs.setFloating}
                style={floatingStyles}
                {...getFloatingProps()}
            >
                <FloatingArrow className={styles.tooltipArrow} context={context} ref={arrowRef} />
                {title != null && <div className={clsx(styles.tooltipTitle, {[styles.center]: centerText})}>{title}</div>}
                {content != null && <div className={clsx(styles.tooltipContent, {[styles.center]: centerText})}>{content}</div>}
            </div>,
            document.body)}
        </>
    )
}
